import TrendsNav from "./TrendsNav";

const { register } = require("@lpm/pug-components/dist/register");

register("TrendsNav/TrendsNav", TrendsNav);